import React, { useState, useCallback, useMemo } from 'react';
import { useOnClickOutside } from 'taboola-ultimate-ui';
import { useNodeWindowOverflow } from '../../hooks/useNodeWindowOverflow';
import { pickerDropdownWidth, pickerDropdownSafePadding } from '../commonPickerDropdownStyle';
import { BreadcrumbsDropdownControl } from './components/BreadcrumbsDropdownControl/BreadcrumbsDropdownControl';
import { BreadcrumbsDropdownMenu } from './components/BreadcrumbsDropdownMenu/BreadcrumbsDropdownMenu';
import styles from './BreadcrumbsDropdown.module.scss';

export const BreadcrumbsDropdown = ({
    label,
    value,
    allOption,
    children,
    fetcher,
    onSelect,
    ItemComponent,
    SearchComponent,
    SortComponent,
    queryKey = '',
    selectedItem,
    dataAutomationId,
    enabled,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const openDropdown = useCallback(() => setIsOpen(true), []);
    const closeDropdown = useCallback(() => setIsOpen(false), []);

    const memoizedQueryKey = useMemo(() => {
        const baseKey = Array.isArray(queryKey) ? queryKey.join('-') : queryKey;
        return `${baseKey}-${inputValue}`;
    }, [queryKey, inputValue]);

    const { containerRef, overflowWidth } = useNodeWindowOverflow({
        requiredWidth: pickerDropdownWidth,
    });

    useOnClickOutside(containerRef, closeDropdown);

    const handleDropdownClick = e => {
        e.stopPropagation();
    };
    const containerStyle = useMemo(() => {
        return overflowWidth ? { left: overflowWidth - pickerDropdownSafePadding } : {};
    }, [overflowWidth]);

    return (
        <div className={styles['container']}>
            <BreadcrumbsDropdownControl
                label={label}
                value={value}
                isOpen={isOpen}
                openDropdown={openDropdown}
                dataAutomationId={dataAutomationId}
            />
            <BreadcrumbsDropdownMenu
                ref={containerRef}
                style={containerStyle}
                inputValue={inputValue}
                onInputChange={setInputValue}
                fetcher={fetcher}
                onSelect={item => {
                    onSelect(item);
                    closeDropdown();
                }}
                closeDropdown={closeDropdown}
                allOption={allOption}
                ItemComponent={ItemComponent}
                SearchComponent={SearchComponent}
                SortComponent={SortComponent}
                isOpen={isOpen}
                selectedItem={selectedItem}
                queryKey={memoizedQueryKey}
                onDropdownClick={handleDropdownClick}
                dataTestId={dataAutomationId}
                dataAutomationId={dataAutomationId}
                enabled={enabled}
            >
                {children}
            </BreadcrumbsDropdownMenu>
        </div>
    );
};
